module.exports = "/cyber/_next/static/images/suggest-modal-top-image-89f0c52489fb503f22a61a041202bea2.webp";